import { Settings } from 'react-slick'
import style from '../BannerSlider.module.scss'

export const slides = [
  { img: '/images/pages/mainSlider/slide-1.png' },
  { img: '/images/pages/mainSlider/slide-2.png' },
  { img: '/images/pages/mainSlider/slide-3.png' },
  { img: '/images/pages/mainSlider/slide-4.png' },
  { img: '/images/pages/mainSlider/slide-5.png' },
]

export const settings: Settings = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: false,
  dotsClass: style.dots,
  className: style.slider,
  responsive: [
    {
      breakpoint: 1279,
      settings: {
        centerMode: true,
        variableWidth: true,
        centerPadding: '0px',
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: false,
        variableWidth: false,
        centerPadding: '0px',
        slidesToShow: 1,
      },
    },
  ],
}
